{
  "metadata": {
    "id": "one-dark-light",
    "name": "One Dark",
    "description": "Портировано из темы «One Dark» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "one-dark.json",
      "project": "Th3Whit3Wolf",
      "url": "https://github.com/Th3Whit3Wolf/one-nvim",
      "upstreamFile": "packages/ui/src/theme/themes/one-dark.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.2,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.446,
      "paletteMaxS": 0.534,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 26.7,
      "syntaxVsTextMinDeltaE": 11.9,
      "chartsMinDeltaE": 31.8,
      "textSeparationDeltaE": 10.3,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "number",
          "b": "type",
          "deltaE": 16.2
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#4078f2",
      "hover": "#3a6cda",
      "active": "#3462c6",
      "foreground": "#000000",
      "muted": "#4078f280",
      "emphasis": "#4078f2"
    },
    "surface": {
      "background": "#fafafa",
      "foreground": "#2f3037",
      "muted": "#ccccce",
      "mutedForeground": "#46474c",
      "elevated": "#b5b6b9",
      "elevatedForeground": "#383a42",
      "raised": "#9a9b9f",
      "raisedForeground": "#31333a",
      "overlay": "#fafafa33",
      "subtle": "#e3e3e4"
    },
    "interactive": {
      "border": "#929398",
      "borderHover": "#c4c4c6",
      "borderFocus": "#4078f2",
      "selection": "#383a4224",
      "selectionForeground": "#383a42",
      "focus": "#4078f259",
      "focusRing": "#4078f247",
      "cursor": "#383a42",
      "hover": "#383a4217",
      "active": "#383a4224"
    },
    "status": {
      "error": "#da3020",
      "errorForeground": "#ffffff",
      "errorBackground": "#da30201a",
      "errorBorder": "#da302059",
      "warning": "#986801",
      "warningForeground": "#ffffff",
      "warningBackground": "#9868011a",
      "warningBorder": "#98680159",
      "success": "#3f7f3e",
      "successForeground": "#ffffff",
      "successBackground": "#3f7f3e1a",
      "successBorder": "#3f7f3e59",
      "info": "#986801",
      "infoForeground": "#ffffff",
      "infoBackground": "#9868011a",
      "infoBorder": "#98680159"
    },
    "pr": {
      "open": "#3f7f3e",
      "draft": "#54545a",
      "blocked": "#986801",
      "merged": "#0184bc",
      "closed": "#da3020"
    },
    "syntax": {
      "base": {
        "background": "#ccccce",
        "foreground": "#383a42",
        "comment": "#54555a",
        "keyword": "#91218f",
        "string": "#30602f",
        "number": "#755001",
        "function": "#015d84",
        "variable": "#a42418",
        "type": "#755001",
        "operator": "#015d84"
      },
      "tokens": {
        "commentDoc": "#54555a",
        "stringEscape": "#015d84",
        "keywordImport": "#91218f",
        "storageModifier": "#91218f",
        "functionCall": "#015d84",
        "method": "#015d84",
        "variableProperty": "#015d84",
        "variableOther": "#a42418",
        "variableGlobal": "#755001",
        "variableLocal": "#015d84",
        "parameter": "#a42418",
        "constant": "#755001",
        "class": "#755001",
        "className": "#755001",
        "interface": "#755001",
        "struct": "#755001",
        "enum": "#755001",
        "typeParameter": "#755001",
        "namespace": "#755001",
        "module": "#91218f",
        "tag": "#91218f",
        "jsxTag": "#91218f",
        "tagAttribute": "#015d84",
        "tagAttributeValue": "#30602f",
        "boolean": "#755001",
        "decorator": "#91218f",
        "label": "#015d84",
        "regexp": "#30602f"
      }
    },
    "charts": {
      "series": [
        "#4078f2",
        "#986801",
        "#3f7f3e",
        "#969801",
        "#da3020"
      ]
    },
    "chat": {
      "background": "#fafafa",
      "userMessage": "#383a42",
      "userMessageBackground": "#b5b6b9",
      "assistantMessage": "#383a42",
      "assistantMessageBackground": "#ccccce",
      "timestamp": "#54545a",
      "divider": "#929398",
      "typing": "#54545a"
    },
    "loading": {
      "spinner": "#4078f2",
      "spinnerTrack": "#ccccce",
      "skeleton": "#ccccce",
      "shimmer": "#c3c3c6"
    },
    "tools": {
      "background": "#ccccce",
      "border": "#929398",
      "headerHover": "#c5c5c7",
      "icon": "#2867f0",
      "title": "#383a42",
      "description": "#54545a",
      "edit": {
        "added": "#3f7f3e",
        "addedBackground": "#3f7f3e1a",
        "removed": "#da3020",
        "removedBackground": "#da30201a",
        "modified": "#986801",
        "modifiedBackground": "#9868011a",
        "lineNumber": "#54545a"
      }
    },
    "markdown": {
      "heading1": "#383a42",
      "heading2": "#383a42",
      "heading3": "#383a42",
      "heading4": "#383a42",
      "link": "#2d6af1",
      "linkHover": "#3a6cda",
      "inlineCode": "#30602f",
      "inlineCodeBackground": "#ccccce",
      "blockquote": "#54545a",
      "blockquoteBorder": "#929398",
      "listMarker": "#3b75f2",
      "bold": "#383a42",
      "italic": "#383a42e6",
      "strikethrough": "#54545a",
      "hr": "#929398"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c45262",
        "foreground": "#000000",
        "contrast": 4.73
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#9e6543",
        "foreground": "#ffffff",
        "contrast": 4.78
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#d4b594",
        "foreground": "#000000",
        "contrast": 10.84
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#aba649",
        "foreground": "#000000",
        "contrast": 8.28
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#b6d697",
        "foreground": "#000000",
        "contrast": 13.05
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#5eca5c",
        "foreground": "#000000",
        "contrast": 10.08
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#4ca16b",
        "foreground": "#000000",
        "contrast": 6.62
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#93dcc9",
        "foreground": "#000000",
        "contrast": 13.32
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#4c9ea1",
        "foreground": "#000000",
        "contrast": 6.71
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#8db4d8",
        "foreground": "#000000",
        "contrast": 9.65
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#3f639b",
        "foreground": "#ffffff",
        "contrast": 6.05
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#30379e",
        "foreground": "#ffffff",
        "contrast": 9.7
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#b98bd6",
        "foreground": "#000000",
        "contrast": 7.73
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#86429b",
        "foreground": "#ffffff",
        "contrast": 6.43
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c45398",
        "foreground": "#000000",
        "contrast": 5.04
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#cc839d",
        "foreground": "#000000",
        "contrast": 7.3
      }
    ]
  }
}
